import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, orange } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const warningColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--status-warning-color-main'],
          highContrast: unityLightTokens['--status-warning-color-high-contrast'],
          lowContrast: unityLightTokens['--status-warning-color-low-contrast'],
        }
      : {
          main: unityDarkTokens['--status-warning-color-main'],
          highContrast: unityDarkTokens['--status-warning-color-high-contrast'],
          lowContrast: unityDarkTokens['--status-warning-color-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: orange[400],
        highContrast: orange[700],
        lowContrast: orange[100],
      }
    : {
        main: orange[400],
        highContrast: orange[100],
        lowContrast: orange[800],
      };
};
